export const events = [
  {
    "id": "tarot-awaken-healer-within",
    "slug": {
      "en": "tarot-awaken-the-healer-within",
      "es": "tarot-awaken-the-healer-within",
      "nl": "tarot-awaken-the-healer-within",
      "pap": "tarot-awaken-the-healer-within"
    },
    "title": {
      "en": "Awaken The Healer Within — Tarot, NLP, and Somatic Psychology",
      "es": "Despierta al Sanador Interior — Tarot, PNL y Psicología Somática",
      "nl": "Wek de Heler in Jezelf — Tarot, NLP en Somatische Psychologie",
      "pap": "Spièrta e Kuradó Interno — Tarot, NLP i Sikologia Somátiko"
    },
    "status": "upcoming",
    "startDate": "2026-07-06",
    "endDate": null,
    "timezone": "Europe/Amsterdam",
    "language": "en",
    "availableLanguages": [
      "en",
      "nl"
    ],
    "location": "/university/",
    "platform": "The Great Work University",
    "description": {
      "en": "Upcoming initiation: The Adept’s Mirror | Sfdw n Tawrt, Awaken The Healer Within. A six-month course in inner alchemy and self-mastery through Tarot, Neuro-Linguistic Programming, and Somatic Psychology. Begins 6 July 2026 inside The Great Work University.",
      "es": "Próxima iniciación: The Adept’s Mirror | Sfdw n Tawrt, Despierta al Sanador Interior. Un curso de seis meses de alquimia interior y autodominio a través del Tarot, la Programación Neurolingüística y la Psicología Somática. Comienza el 6 de julio de 2026 dentro de The Great Work University.",
      "nl": "Aankomende initiatie: The Adept’s Mirror | Sfdw n Tawrt, Wek de Heler in Jezelf. Een cursus van zes maanden in innerlijke alchemie en zelfmeesterschap via Tarot, Neurolinguïstisch Programmeren en Somatische Psychologie. Begint op 6 juli 2026 binnen The Great Work University.",
      "pap": "Inisiashon ku ta bin: The Adept’s Mirror | Sfdw n Tawrt, Spièrta e Kuradó Interno. Un kurso di seis luna di alkimia interno i outodominio via Tarot, Programashon Neurolingwístiko i Sikologia Somátiko. Ta kuminsá 6 di yüli 2026 paden di The Great Work University."
    },
    "ctaLabel": {
      "en": "Enter University",
      "es": "Entrar a la Universidad",
      "nl": "Naar de Universiteit",
      "pap": "Drenta Universidat"
    },
    "ctaUrl": "/university/",
    "replayUrl": null,
    "image": "/assets/images/tarot1.png",
    "imageAlt": "Awaken The Healer Within Tarot course flyer",
    "relatedProgram": null,
    "relatedCourse": "tarot-great-work-practitioner"
  }
];
